import React from "react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import { getToolTipAttributes } from "../../../../utils/tooltip";

const ApplicationCell = ({ item, onCopyId }) => {
  // Helper for text formatting
  const toTitleCase = (str) => {
    if (!str) return "";
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Reusable style for text truncation
  const textTruncateStyle = {
    maxWidth: "160px",
    display: "inline-block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  };

  return (
    <div className="d_flex flex_column gap_1 align_start" style={{ width: "100%", overflow: "hidden" }}>
      {/* Primary Row: Application Name & Version */}
      <div
        className="d_flex align_center gap_1"
        style={{ width: "100%", minWidth: 0 }} // 🔑 minWidth fixes flex truncation
      >
        <MaterialIcon
          name="deployed_code"
          filled
          type="rounded"
          style={{
            fontSize: "14px",
            color: "#4B5563", // neutral slate
            flexShrink: 0 // icon never shrinks
          }}
        />

        <span
          className="font_weight_bold"
          style={{
            ...textTruncateStyle,
            fontSize: "13px",
            color: "#111827",
            maxWidth: "100%",
            flex: 1, // text takes remaining space
            minWidth: 0 // required for ellipsis in flex
          }}
          {...getToolTipAttributes(item?.app_name)}
        >
          {item?.app_name ? toTitleCase(item.app_name) : "Unknown App"}
        </span>
      </div>

      {/* Secondary Row: Org Name & ID */}
      <div className="d_flex flex_column gap_1" style={{ width: "100%" }}>
        {/* Organization */}
        <div className="d_flex align_center gap_1" style={{ fontSize: "12px" }}>
          <MaterialIcon name="corporate_fare" style={{ fontSize: "12px" }} />
          <span className="font_weight_normal" style={textTruncateStyle} {...getToolTipAttributes(item?.org_name)}>
            {item?.org_name ? toTitleCase(item.org_name) : "Unknown Org"}
          </span>
          <ButtonActionIcon
            type="content_copy"
            size="xxsm"
            tooltip="Copy App ID"
            onClick={(e) => onCopyId(e, item.app_id, "App ID")}
            style={{ padding: 0, opacity: 0.7 }}
          />
        </div>
      </div>
    </div>
  );
};

export default ApplicationCell;
